import { Component, input, model } from '@angular/core';
import { NgClass } from '@angular/common';
import { Tab, RFI_TABS } from '@app/framework/underline-tabs/underline-tabs.types';

@Component({
  selector: 'app-underline-tabs',
  imports: [NgClass],
  templateUrl: './underline-tabs.component.html',
  styleUrl: './underline-tabs.component.scss',
})
export class UnderlineTabsComponent {
  tabs = input.required<Tab[]>();
  selectedTab = model.required<RFI_TABS>();

  selectTab(value: RFI_TABS) {
    this.selectedTab.set(value);
  }
}
